import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import SwiperCore, { SwiperOptions, Navigation, Pagination } from 'swiper';
import { generateSlug } from 'src/app/helpers/slug-helper';
import { StoreService } from 'src/app/services/store.service';
import { createDeptUrl } from 'src/app/helpers/url-helper';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/services/utils.service';
import { CallAPIService } from 'src/app/services/call-api.service';

SwiperCore.use([Navigation, Pagination]);

@Component({
  selector: 'app-service-slider',
  templateUrl: './service-slider.component.html',
  styleUrls: ['./service-slider.component.scss'],
})
export class ServiceSliderComponent implements OnInit {
  loadingSrvs = Array.from({ length: 5 });
  public isEnglishLang: any;
  serviceSliderConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: true,
    lazy:true,
    pagination: { clickable: true },
    mousewheel: true,
    autoplay: {
      delay: 2500
    },
    breakpoints: {
      1024: {
        slidesPerView: 5,
      },
      576: {
        slidesPerView: 2.5,
      },
      480: {
        slidesPerView: 1.5,
      },
    },
  };

  @Input() heading!: string;
  @Input() subHeading!: string;
  @Input() srvNameKey!: string;
  @Input() logoUrlKey!: string;
  @Input() srvIdKey!: string;
  @Input() isLoading!: boolean;
  @Input() services!: any[];
  @Input() isWhatsNew!: any;
  @Input() isPopular: boolean = false;
  @Input() displayKey:string = ''
  constructor(private router: Router, private storeService: StoreService, private utilService: UtilsService, private callApiService: CallAPIService) { }

  ngOnInit() {
    this.storeService.langCode.subscribe((res) => {
      this.isEnglishLang = res;
    })
  }

  onServiceCardClick(serviceName: string, service: any) {
    if (!serviceName) {
      return;
    }
    if (this.isPopular) {
      this.redirectToService(service);
      return
    }
    this.router.navigateByUrl(`/department/${generateSlug(serviceName)}`);
  }


  redirectToService(
    serviceObj: any,
    customMsg?: string
  ) {
    this.callApiService
      .fetchDeptServices(serviceObj.dept_id).subscribe({
        next: (resp: any) => {
          const services: any = resp;
          const isLoadService = this.utilService.checkSrvAccess(
            serviceObj.service_id,
            serviceObj,
            services
          );

          if (!isLoadService) {
            return;
          }

          const webNewUrl = `${environment.deployUrl}/web_new/department`;
          const isUrlV2 = serviceObj.service_url.includes('UmangVersion2');
          const isUrlDeptt = serviceObj.service_url.includes('deptt');
          if (isUrlV2) {
            const urlParams = encodeURIComponent(
              `${createDeptUrl(serviceObj.service_url)}&dept_id=${serviceObj.dept_id}&dept_name=${serviceObj.service_url}`
            );
            window.open(`${webNewUrl}?url=${urlParams}`, '_self');
            return;
          } else if (isUrlDeptt) {
            const encodedUrlParam = encodeURIComponent(`${createDeptUrl(serviceObj.deptUrl)}`);
            window.open(
              `${webNewUrl}?url=${encodedUrlParam}&dept_id=${serviceObj.dept_id}&dept_name=${serviceObj.dept_name}`,
              '_self'
            );
            return;
          }
          const urlParams =
            encodeURIComponent(`${serviceObj.service_url.split('gov.in/')[1]}`) +
            `&dept_id=${serviceObj.dept_id}&dept_name=${serviceObj.dept_name}`;
          window.open(`${webNewUrl}?url=${urlParams}`, '_self');
        }
      })

  }
}
